////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const kioskEditSetup = {
	getKioskSetup: (id) => ({
		type: ActionsTypes.GET_KIOSK_SETUP,
		payload: {
			id,
		},
	}),
	getKioskSetupSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_SETUP_SUCCESS,
		payload: {
			data,
		},
	}),
	getKioskSetupFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_SETUP_FAILURE,
		payload: {
			error,
		},
	}),
	putEditKioskSetup: (idKiosk, data) => ({
		type: ActionsTypes.PUT_EDIT_KIOSK_SETUP,
		payload: {
			idKiosk,
			data,
		},
	}),
	putEditKioskSetupSuccess: (data) => ({
		type: ActionsTypes.PUT_EDIT_KIOSK_SETUP_SUCCESS,
		payload: {
			data,
		},
	}),
	putEditKioskSetupFaillure: (error) => ({
		type: ActionsTypes.PUT_EDIT_KIOSK_SETUP_FAILURE,
		payload: {
			error,
		},
	}),
	viewProductionFile: (requestId) => ({
		type: ActionsTypes.VIEW_PRODUCTION_FILE,
		payload: {
			requestId,
		},
	}),
	viewProductionFileSuccess: (data) => ({
		type: ActionsTypes.VIEW_PRODUCTION_FILE_SUCCESS,
		payload: {
			data,
		},
	}),
	viewProductionFileFailure: (error) => ({
		type: ActionsTypes.VIEW_PRODUCTION_FILE_FAILURE,
		payload: {
			error,
		},
	}),
}

export default kioskEditSetup
